import {
  newModal,
  closeModal,
  getContent,
  mergeContent,
  removeContent,
  addContent,
} from "@js/helpers/state.js";

import {
  CE_REMOVE_CONTENT_OPEN,
  CE_REMOVE_CONTENT_CONFIRM,
} from "@js/actions/studio/campaign_content_section/remove_content.js";

import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export default (state = {}, action) => {
  let contentLength = state.data.contents.length;
  let clearingContent = contentLength === 1 && action.part === "whole";
  switch (action.type) {
    case CE_REMOVE_CONTENT_OPEN:
      return newModal(state, "modal_confirmation", {
        part: action.part,
        title: t(
          `phrases.react_content.${
            clearingContent ? "clear_content_warning" : "delete_content_warning"
          }.title`,
        ),
        warning: t(
          `phrases.react_content.${
            clearingContent ? "clear_content_warning" : "delete_content_warning"
          }.${action.part}`,
        ),
        dangerous: true,
        save_text: clearingContent
          ? t(`phrases.react_content.action_dropdown.clear_content`)
          : t(`buttons.delete_this_content`),
        save_action: {
          type: CE_REMOVE_CONTENT_CONFIRM,
          client_content_id: action.client_content_id,
        },
        cancel_action: { type: CE_MODAL_CLOSE },
      });

    case CE_REMOVE_CONTENT_CONFIRM:
      let { part } = state.modal.state;
      switch (part) {
        case "whole":
          let requiresNewContent = state.data.contents.length === 1;
          let stateWithContentRemoved = closeModal(
            removeContent(state, action.client_content_id),
          );
          if (requiresNewContent) {
            let blankContent = {
              name: "Content (1)",
              subject: "",
              format: "html",
              html: "",
              text: "",
              bee_json: null,
              active_html_editor: "bee",
            };
            return addContent(stateWithContentRemoved, blankContent);
          } else {
            return stateWithContentRemoved;
          }
        case "html": {
          let content = getContent(state, action.client_content_id);

          if (content.format === "html") {
            return closeModal(state);
          } else {
            return closeModal(
              mergeContent(state, action.client_content_id, {
                format: "text",
                html: "",
                bee_json: "",
              }),
            );
          }
        }

        case "text": {
          let content = getContent(state, action.client_content_id);

          if (content.format === "text") {
            return closeModal(state);
          } else {
            return closeModal(
              mergeContent(state, action.client_content_id, {
                format: "html",
                text: "",
              }),
            );
          }
        }

        default:
          return closeModal(state);
      }

    default:
      return state;
  }
};
